import { LayoutState } from "../layout.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";

export const setLoadingReducer = (
  state: LayoutState,
  action: PayloadAction<boolean>,
) => {
  state.isLoading = action.payload;
};

export const enableLoadingReducer = (state: LayoutState) => {
  state.isLoading = true;
};

export const disableLoadingReducer = (state: LayoutState) => {
  state.isLoading = false;
  state.isTimeOfferModalOpen = false;
};

export const enableSessionLoadingReducer = (state: LayoutState) => {
  state.isSessionLoading = true;
};

export const disableSessionLoadingReducer = (state: LayoutState) => {
  state.isSessionLoading = false;
};
